import React, { useState, useEffect } from "react";
import { getPaymentMethosds, getTransaction, signOut } from "../config/config";

import { GoArrowSwitch } from "react-icons/go";
import {
  TransactionStatusNames,
  TransactionStatus,
} from "../enum/TransactionStatus";
import { FaTimesCircle, FaCheckCircle, FaSignOutAlt } from "react-icons/fa";
import {
  FaMagnifyingGlass,
  FaFilterCircleXmark,
  FaCirclePlus,
  FaRepeat,
  FaSpinner,
  FaRotateRight,
  FaFilter,
} from "react-icons/fa6";
import { TransactionType, TransactionTypeNames } from "../enum/TransactionType";
import Pagination from "../component/Pagination";

const Transaction = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [paymentMethod, setPaymentMethod] = useState([]);
  const [paymentMethodError, setPaymentMethodError] = useState("");
  const [filteredTransaction, setFilteredTransaction] = React.useState([]);

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [isFilterOpen, setIsFilterOpen] = useState(true); // filter hide and show
  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const [filters, setFilters] = useState({
    pageSize: "10",
    status: "",
    paymentMethod: "",
    startDate: "",
    endDate: "",
    searchText: "",
  });

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const itemsPerPage = parseInt(filters.pageSize, 10);

  const paginatedTransaction = filteredTransaction.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const fetchTransaction = async (queryParams = {}) => {
    try {
      setIsLoading(true);
      const result = await getTransaction(queryParams);

      if (result.success) {
        setData(result.data);
        setFilteredTransaction(result.data || []);
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchData = async (apiCall, setData, setError) => {
    try {
      const result = await apiCall();
      if (result.success) {
        setData(result.data || []);
      } else {
        setError(result.message || "An error occurred.");
      }
    } catch (err) {
      setError(err.message || "An unexpected error occurred.");
    }
  };

  const handleInputChange = (e, field) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: e.target.value,
    }));
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case TransactionStatus.Pending:
        return <FaSpinner className="icon-spinner" color="#fac20c" />;
      case TransactionStatus.New:
        return <FaSpinner className="icon-spinner" color="#fac20c" />;
      case TransactionStatus.Confirm:
        return <FaCheckCircle className="icon-confirm text-success" />;
      case TransactionStatus.Reject:
        return <FaTimesCircle className="icon-reject text-danger" />;
      default:
        return null;
    }
  };

  const handleSearch = () => {
    const { fromDate, toDate } = filters;

    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      setError("Start date or end date cannot be later than the current date.");
      alert("Start date or end date cannot be later than the current date.");
      return;
    }

    setIsLoading(true);

    const queryParams = Object.keys(filters).reduce((acc, key) => {
      if (filters[key]) {
        if (key === "fromDate" || key === "toDate") {
          acc[key] = new Date(filters[key]).toISOString();
        } else {
          acc[key] = filters[key];
        }
      }
      return acc;
    }, {});

    fetchTransaction(queryParams);
  };

  const handleClearFilters = () => {
    setFilters({
      pageSize: "10",
      status: "",
      paymentMethod: "",
      startDate: "",
      endDate: "",
      searchText: "",
    });
    setIsLoading(true);
    fetchTransaction();
  };

  const refreshData = (filters) => {
    setIsLoading(true);
    fetchTransaction(filters);
  };

  useEffect(() => {
    fetchData(getPaymentMethosds, setPaymentMethod, setPaymentMethodError);
  }, []);
  useEffect(() => {
    fetchData(getPaymentMethosds, setPaymentMethod, setPaymentMethodError);
  }, []);

  useEffect(() => {
    const totalPages = Math.ceil(filteredTransaction.length / itemsPerPage);
    setTotalPages(totalPages);
  }, [filteredTransaction, itemsPerPage]);

  useEffect(() => {
    fetchTransaction();
  }, []);

  return (
    <div
      className="w-100  p-3"
      style={{ backgroundColor: "#a4bdc8", minHeight: "100vh" }}
    >
      <div
        className="container mt-3 p-3 rounded"
        style={{ backgroundColor: "#fff" }}
      >
        <div className="d-flex flex-row align-items-center justify-content-between gap-2 mb-3">
          <div>
            {" "}
            <GoArrowSwitch size={30} />
            <span className="fs-5">Transaction</span>
          </div>
          <div>
          <FaSignOutAlt size={30} onClick={signOut}/>
          </div>
        </div>
        <div>
          <div className="d-flex justify-content-start mb-3">
            <span
              className="btn btn-sm btn-outline-primary mb-1 me-1  d-flex align-items-center justify-content-center"
              onClick={refreshData}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <FaSpinner className="me-1 spin-animation" />
                  Loading...
                </>
              ) : (
                <>
                  <FaRotateRight className="me-1" />
                  Reload
                </>
              )}
            </span>
            <span
              className="btn btn-sm btn-outline-secondary mb-1 me-1  d-flex align-items-center justify-content-center"
              onClick={toggleFilter}
            >
              <FaFilter size={13} className="me-1" />
              Filter
            </span>
          </div>

          {/* FİLTRELEME */}
          <div
            className={`row filter-section ${isFilterOpen ? "open" : "closed"}`}
            style={{
              transition: "all 0.3s ease-in-out", // kapanıp açılırken daha smooth
              maxHeight: isFilterOpen ? "1000px" : "0",
              overflow: "hidden",
            }}
          >
            {" "}
            <div className="row">
              <div className="col-auto mb-1">
                <label className="small-label">Page Size</label>
                <select
                  className="form-select form-select-sm"
                  onChange={(e) => handleInputChange(e, "pageSize")}
                >
                  <option value="10">10</option>
                  <option value="20">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>

              <div className="col-auto mb-1">
                <label className="small-label">Type</label>
                <select
                  className="form-select form-select-sm"
                  onChange={(e) => handleInputChange(e, "transactionType")}
                >
                  <option value="">Select</option>
                  {Object.values(TransactionType).map((type) => (
                    <option key={type} value={type}>
                      {TransactionTypeNames[type]}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-auto mb-1">
                <label className="small-label">Status</label>
                <select
                  className="form-select form-select-sm"
                  onChange={(e) => handleInputChange(e, "transactionStatus")}
                >
                  <option value="">Select</option>
                  {Object.values(TransactionStatus).map((type) => (
                    <option key={type} value={type}>
                      {TransactionStatusNames[type]}
                    </option>
                  ))}
                </select>
              </div>
              {/* plc wallet gizlendi  idsi 11*/}
              <div className="col-2 mb-1">
                <label className="small-label">Payment Method</label>
                <select
                  className="form-select form-select-sm"
                  onChange={(e) => handleInputChange(e, "paymentMethod")}
                >
                  <option value="">Select</option>
                  {paymentMethod
                    .filter((method) => method.id !== 11)
                    .map((paymentMethod) => (
                      <option key={paymentMethod.id} value={paymentMethod.id}>
                        {paymentMethod.name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-auto mb-1">
                <label className="small-label">Start Date</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  onChange={(e) => handleInputChange(e, "fromDate")}
                />
              </div>

              <div className="col-auto mb-1">
                <label className="small-label">End Date</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  onChange={(e) => handleInputChange(e, "toDate")}
                />
              </div>

              <div className="col-2 mb-1">
                <label className="small-label">Search Text</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  onChange={(e) => handleInputChange(e, "searchText")}
                />
              </div>

              <div className="col-1 mb-1 d-flex align-items-end justify-content-center">
                <button
                  className="btn btn-outline-secondary btn-sm w-100"
                  onClick={handleSearch}
                >
                  <FaMagnifyingGlass
                    size={13}
                    className="me-1"
                    onClick={handleSearch}
                  />
                  Search
                </button>
              </div>

              <div className="col-1 mb-1 d-flex align-items-end justify-content-center">
                <button
                  className="btn btn-outline-secondary btn-sm w-100"
                  onClick={handleClearFilters}
                >
                  <FaFilterCircleXmark size={13} className="me-1" />
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* TABLO */}

        <div
          className="table-container  mt-2"
          style={{ backgroundColor: "#fff" }}
        >
          {paginatedTransaction.length === 0 ? (
            <div
              className="alert alert-info fw-normal mt-4"
              style={{ textAlign: "center" }}
            >
              No data found
            </div>
          ) : (
            <table className="table" style={{ backgroundColor: "#f8f9fa" }}>
              <thead>
                <tr>
                  <th style={{ width: "3%" }}></th>
                  <th style={{ width: "4.5%" }}>Id</th>
                  <th>Member</th>
                  <th style={{ textAlign: "right", width: "16%" }}>Amount</th>
                  <th style={{ textAlign: "center" }}>Date</th>
                  <th style={{ textAlign: "left" }}>Payment Method</th>
                  <th style={{ width: "90px" }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {paginatedTransaction.map((row) => (
                  <tr key={row.id}>
                    <td> {getStatusIcon(row.transactionStatus)}</td>
                    <td>{row.id}</td>
                    <td>
                      <div className="d-flex flex-column">
                        <span style={{ fontWeight: "500" }}>
                          {row.firstName} {row.lastName}
                        </span>
                        <span className="text-secondary">{row.username}</span>
                      </div>
                    </td>
                    <td style={{ textAlign: "right", fontSize: "12px" }}>
                      <div
                        className="d-flex flex-row align-items-end justify-content-end gap-1"
                        style={{
                          color: row.amount > 0 ? "green" : "inherit",
                        }}
                      >
                        {" "}
                        <span style={{ fontSize: "15px", fontWeight: "800" }}>
                          {new Intl.NumberFormat("tr-TR", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            useGrouping: true,
                          })
                            .format(row.amount || 0)
                            .replace(/,/g, "@")
                            .replace(/\./g, ",")
                            .replace(/@/g, ".")}{" "}
                        </span>
                        <span style={{ textAlign: "right", fontSize: "14px" }}>
                          {row.currency}
                        </span>
                      </div>
                    </td>

                    <td style={{ textAlign: "center" }}>
                      {(() => {
                        const transactionTime = new Date(row.transactionTime);
                        const day = transactionTime
                          .getDate()
                          .toString()
                          .padStart(2, "0");
                        const month = (transactionTime.getMonth() + 1)
                          .toString()
                          .padStart(2, "0"); // Aylar 0'dan başlar, +1 ekliyoruz
                        const year = transactionTime.getFullYear();
                        const hours = transactionTime
                          .getHours()
                          .toString()
                          .padStart(2, "0");
                        const minutes = transactionTime
                          .getMinutes()
                          .toString()
                          .padStart(2, "0");
                        const seconds = transactionTime
                          .getSeconds()
                          .toString()
                          .padStart(2, "0");
                        return `${day}.${month}.${year} \n${hours}:${minutes}:${seconds}`;
                      })()}
                    </td>
                    <td>
                      <div>
                        <span>{row.companyPaymentMethodName}</span>
                      </div>
                    </td>
                    <td>
                      <span
                        style={{
                          backgroundColor:
                            row.transactionStatus === 1
                              ? "blue"
                              : row.transactionStatus === 2
                              ? "#ffc008"
                              : row.transactionStatus === 3
                              ? "green"
                              : row.transactionStatus === 4
                              ? "#dc3445"
                              : "transparent",
                          color: "white",
                          fontWeight: "bold",
                          padding: "3px",
                          borderRadius: "4px",
                          textAlign: "center",
                          fontSize: "13px",
                        }}
                      >
                        {" "}
                        {TransactionStatusNames[row.transactionStatus] ||
                          "Unknown"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>

              <tfoot>
                <tr>
                  <td
                    colSpan="3"
                    className="fs-6"
                    style={{ textAlign: "left", fontWeight: "bold" }}
                  >
                    Total
                  </td>
                  <td
                    colSpan="1"
                    style={{ textAlign: "right", fontWeight: "bold" }}
                  >
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      <span>
                        {" "}
                        {new Intl.NumberFormat("tr-TR", {
                          style: "decimal",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          useGrouping: true,
                        })
                          .format(
                            data.reduce((total, row) => total + row.amount, 0)
                          )
                          .replace(/,/g, "@")
                          .replace(/\./g, ",")
                          .replace(/@/g, ".")}{" "}
                      </span>
                      <span
                        className="text-secondary"
                        style={{ fontWeight: "500" }}
                      >
                        {" "}
                        CUR
                      </span>
                    </div>
                  </td>
                  <td colSpan="6"></td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
        <div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default Transaction;
